module.exports = __webpack_public_path__ + "static/media/beer-ca.ed952d02.png";